var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C3421;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M866.1,1059.9H213.7c-11,0-20-9-20-20V288.6c0-11,9-20,20-20s20,9,20,20v731.3h612.4V288.6c0-11,9-20,20-20 s20,9,20,20v751.3C886.1,1051,877.2,1059.9,866.1,1059.9z M736.2,130.6V40.1c0-11-9-20-20-20H393.3c-11,0-20,9-20,20v90.5 c0,11,9,20,20,20s20-9,20-20V60.1h282.9v70.5c0,11,9,20,20,20S736.2,141.6,736.2,130.6z M998.2,204.3c0-11-9-20-20-20H104.9 c-11,0-20,9-20,20s9,20,20,20h873.3C989.2,224.3,998.2,215.3,998.2,204.3z M395.5,868.6V459.9c0-11-9-20-20-20s-20,9-20,20v408.7 c0,11,9,20,20,20S395.5,879.7,395.5,868.6z M724.3,868.6V459.9c0-11-9-20-20-20s-20,9-20,20v408.7c0,11,9,20,20,20 S724.3,879.7,724.3,868.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2fce39a1e0d7bc94f024e0b9020c4a48.svg";
export { ForwardRef as ReactComponent };